module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "epi"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("“But dreadful is the mysterious"), _c('br'), _vm._v("power of fate; there is no"), _c('br'), _vm._v("deliverance from it by wealth or by war, by"), _c('br'), _vm._v("fenced city, or dark, sea-"), _c('br'), _vm._v("beaten ships.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Chorus, "), _c('em', [_vm._v("Antigone")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cef6930","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795335020_epi.vue
// module id = 69
// module chunks = 0